export const productsQueryKeys = {
  all: ["products"],
  allWithParams: (params: Record<string, unknown>) => [
    ...productsQueryKeys.all,
    params,
  ],
} as const;
